import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import clsx from 'clsx';
import { omit } from 'lodash';
import { TimePicker as MUITimePicker, } from '@mui/x-date-pickers/TimePicker';
import { styled } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
export function timeStringToDate(time) {
    const date = new Date();
    if (!time) {
        date.setHours(9);
        date.setMinutes(0);
    }
    else {
        const [hours, minutes] = time.split(':');
        date.setHours(parseInt(hours, 10));
        date.setMinutes(parseInt(minutes, 10));
    }
    return date;
}
export function dateToTimeString(date) {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    return `${hours}:${minutes}`;
}
const getAlignment = align => ({
    '& input': {
        textAlign: align,
    },
});
const useStyles = makeStyles(theme => createStyles({
    noLabelWrap: {
        '& p': {
            whiteSpace: 'nowrap',
        },
        '& label': {
            whiteSpace: 'nowrap',
        },
    },
    left: getAlignment('left'),
    center: getAlignment('center'),
    right: getAlignment('right'),
    '&.MuiPickersToolbarText-toolbarTxt': {
        color: 'white',
    },
}));
const TimePickerRoot = styled(MUITimePicker, {
    name: 'TimePicker',
    slot: 'root',
})({});
export default function TimePicker(props) {
    const { helperText, value, format, align, noLabelWrap, className, onChange, } = props;
    const classes = useStyles();
    const [currentValue, setCurrentValue] = useState(value);
    useEffect(() => {
        setCurrentValue(value);
    }, [value]);
    const alignClass = classes[align || 'left'];
    const noLabelWrapClass = classes[noLabelWrap ? 'noLabelWrap' : ''];
    const handleChange = (dateValue, context) => {
        if (onChange) {
            onChange(dateValue, context);
        }
        else {
            setCurrentValue(dateValue);
        }
    };
    return (_jsx(TimePickerRoot, Object.assign({ slotProps: {
            textField: {
                helperText,
                variant: 'standard',
            },
            popper: {
                sx: {
                    '& .MuiMultiSectionDigitalClockSection-root': {
                        width: '65px',
                    },
                },
            },
        } }, omit(props, ['align', 'format', 'keyboardIcon', 'className', 'value', 'noLabelWrap']), { value: currentValue, onChange: handleChange, className: clsx([className], noLabelWrapClass, alignClass), format: format || 'hh:mm' })));
}
